// extracted by mini-css-extract-plugin
module.exports = {"RecipeCardWrapper":"RecipeDetail_RecipeCardWrapper__ZvWvI","RecipeCard":"RecipeDetail_RecipeCard__oLHe9"};